var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendmessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2071 0.792921C21.4788 1.06456 21.5708 1.46779 21.4439 1.83038L14.7939 20.8304C14.6584 21.2174 14.3004 21.4825 13.8908 21.4992C13.4811 21.5159 13.1027 21.2808 12.9362 20.9062L9.2924 12.7076L1.09387 9.06384C0.719186 8.89731 0.484122 8.51894 0.500836 8.10926C0.51755 7.69959 0.782654 7.34162 1.16965 7.20617L20.1697 0.55617C20.5322 0.429264 20.9355 0.521283 21.2071 0.792921ZM11.2428 12.1715L13.7394 17.789L18.1085 5.30571L11.2428 12.1715ZM16.6943 3.8915L4.21108 8.26063L9.82854 10.7573L16.6943 3.8915Z",
    fill: "#E94057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendmessage);
export default __webpack_public_path__ + "static/media/Sendmessage.1ef9608d03faf64c78d3b998c98f0730.svg";
export { ForwardRef as ReactComponent };